// import { UpButton } from "components/Button/Button";
// // import React from "react";
// // import { POST_FILE_UPLOAD } from "helpers/api_constants";
// import { post } from "helpers/api_helper";
// import React, { useRef } from "react";
// import Frame from "../../assets/images/Frame2.svg";
// import {ReactComponent as Frame1} from "../../assets/images/Frame1.svg";
 
// const FileUpload = ({
//   handleFileResponse,
//   validFileTypes = ["image/jpeg", "image/png", "application/pdf"],
//   maxFileSizeMB = 5,
// }) => {
//   const buttonRef = useRef();
 
//   const handleFileChange = (file) => {};
 
// //   const handleFileUpload = async (file) => {
// //     const formData = new FormData();
// //     formData.append("file", file);
// //     const response = await post(POST_FILE_UPLOAD, formData, {
// //       headers: {
// //         "Content-Type": "multipart/form-data",
// //       },
// //     }
// // );
 
// //     if (!response) {
// //       throw new Error("Upload failed");
// //     } else {
// //       handleFileResponse(response || {});
// //     }
// //   };
 
// //   const handleFileInputRef = () => {
// //     if (buttonRef.current) {
// //       buttonRef.current.click();
// //     }
// //   };
 
//   return (
//     <div>
//       <UpButton
//         ref={buttonRef}
//         maxFileSizeMB={maxFileSizeMB}
//         validFileTypes={validFileTypes}
//         onFileChange={handleFileChange}
//         // apiCallHandler={handleFileUpload}
//         isUploading={false}
//       >
//       <div className="flex flex-col items-center justify-center gap-2">
//       {/* <img src="../../assets/images/Frame1.svg"  alt="Frame1" />
//         Upload File */}
//          <Frame1 />
//          Upload File
//       </div>
       
//       </UpButton>
//     </div>
//   );
// };
 
// export default FileUpload;

import { UpButton } from "components/Button/Button";

import { post } from "helpers/api_helper";
import React, { useRef } from "react";
 
const FileUpload = ({
  handleFileResponse,
  validFileTypes = ["image/jpeg", "image/png", "application/pdf"],
  maxFileSizeMB = 5,
  existingFile = {},
  handleRemoveFileParent
}) => {
  const buttonRef = useRef();
 
  const handleFileChange = (file) => { };
 
  const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await post("https://backend.fynlinc.in/fileservice/api/files/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
 
    if (!response) {
      throw new Error("Upload failed");
    } else {
      handleFileResponse(response || {});
    }
  };
 
  const removeFile = () => {
    handleRemoveFileParent();
  }
 
  return (
    <div>
      <UpButton
        // ref={buttonRef}
      
        maxFileSizeMB={maxFileSizeMB}
        validFileTypes={validFileTypes}
        // onFileChange={handleFileChange}
        apiCallHandler={handleFileUpload}
        handleRemoveFileParent={removeFile}
        isUploading={false}
        existingFile={existingFile || {}}
      >
        <div className="flex flex-col items-center  xl:w-[250px]  justify-center gap-2">
          <img src="/images/fileUpload.svg" className="h-[44px]" />
          <h1 className="font-medium text-black-900 mt-2">Drag and drop files here</h1>
          <p>File Format: PDF/ JPEG/ PNG</p>
          <button className="p-2 text-white  rounded-lg w-[144px] font-semibold bg-[#5665B0] m-1">Browse</button>
          <p className="text-xs font-normal font-sans">Max size: {maxFileSizeMB}MB  </p>
         
 
        </div>
 
      </UpButton>
    </div>
  );
};
 
FileUpload.defaultProps = {
  existingFile: null,
  handleRemoveFileParent: () => {},
};
 
 
 
export default FileUpload;